var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control",attrs:{"autocomplete":"off"},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }